import { TouchableOpacity, View, Text, Image } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import type { Dog } from "../app/lib/types";

interface DogCardProps {
  dog: Dog;
  onPress: () => void;
}

export function DogCard({ dog, onPress }: DogCardProps) {
  const handicap = dog.handicap ? parseFloat(dog.handicap) : null;
  const handicapLabel = handicap === 1.0 ? "1.0×" : handicap === 1.5 ? "1.5×" : handicap === 2.0 ? "2.0×" : null;

  return (
    <TouchableOpacity
      onPress={onPress}
      style={{
        backgroundColor: "#ffffff",
        borderRadius: 12,
        padding: 16,
        marginBottom: 12,
        flexDirection: "row",
        alignItems: "center",
        borderWidth: 1,
        borderColor: "#e5e7eb",
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.05,
        shadowRadius: 3,
        elevation: 2,
      }}
    >
      {dog.photo ? (
        <Image
          source={{ uri: dog.photo }}
          style={{ width: 48, height: 48, borderRadius: 24, marginRight: 14 }}
        />
      ) : (
        <View
          style={{
            width: 48,
            height: 48,
            borderRadius: 24,
            backgroundColor: "#F0F2F5",
            alignItems: "center",
            justifyContent: "center",
            marginRight: 14,
          }}
        >
          <Ionicons name="paw" size={24} color="#1B2A4A" />
        </View>
      )}

      <View style={{ flex: 1 }}>
        <Text style={{ fontSize: 16, fontWeight: "700", color: "#1B2A4A" }}>{dog.name}</Text>
        <Text style={{ fontSize: 15, color: "#6B7280", marginTop: 2 }}>{dog.breed}</Text>
        {handicapLabel && (
          <Text style={{ fontSize: 14, color: "#F5A623", marginTop: 3, fontWeight: "500" }}>
            Handicap {handicapLabel}
          </Text>
        )}
      </View>

      <Ionicons name="chevron-forward" size={20} color="#9ca3af" />
    </TouchableOpacity>
  );
}
